var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon16PxPresentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H12V4h.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-10c-.276 0-.5.224-.5.5s.224.5.5.5H3v5h-.5c-.276 0-.5.224-.5.5s.224.5.5.5H7v.575l-2.275 1.5c-.192.119-.28.351-.216.567.064.217.265.363.491.358.098.001.194-.029.275-.085L7 11.775v.725c0 .276.224.5.5.5s.5-.224.5-.5v-.725l1.725 1.14c.08.056.177.086.275.085.22-.002.412-.146.475-.356s-.018-.437-.2-.56L8 10.585V10h4.5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM11 9H4V4h7v5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon16PxPresentation);
export default __webpack_public_path__ + "static/media/4-icon-16-px-presentation.d68def70.svg";
export { ForwardRef as ReactComponent };